<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('esl_instructor_sessions')" :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('esl_instructor_sessions')" :isFilter="false" />
            </template>
            <div class="mb-5 align-items-center">
                <template v-if="loading">
                    <b-col  class="d-flex justify-content-center align-items-center" style="min-height: 400px">
                        <b-spinner variant="primary" label="Loading..."></b-spinner>
                    </b-col>
                </template>
                <template v-else-if="!sessions.length && !loading">
                    <div class="col-12">
                        <div class="row border p-2 d-flex justify-content-center align-items-center">
                            <div class="d-flex flex-column align-items-center">
                                <i class="ri-information-line" style="font-size: 100px">
                                </i>
                                <p class="text-black-90">{{ $t('no_course') }}!</p>
                            </div>
                        </div>
                    </div>
                </template>
                <b-card-group deck v-else>
                    <div v-for="(item, key) in sessions" class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4" :key="key">
                        <b-card bg-variant="light" :header="item.classroom_name" class="text-center cursor"
                                @click="showDetail(item.id)">
                            <b-card-text>{{ item.course_name }}</b-card-text>
                        </b-card>
                    </div>
                </b-card-group>

            </div>
            <CommonModal size="xl" ref="detailModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('course_detail_title').toUpper() }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <SessionDetails v-if="process === 'course_detail'" :selectedData="selectedData"  ></SessionDetails>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Page

// Component
import CommonModal from "@/components/elements/CommonModal";

import EslInstructorService from "@/services/EslInstructorService";
import SessionDetails from "@/modules/eslInstructorSessions/pages/SessionDetails.vue";

export default {
    components: {
        SessionDetails,
        AppLayout,
        Header,
        HeaderMobile,
        CommonModal,},
    data() {
        return {
            selectedData: null,
            sessions: [],
            selectedId: null,
            process: null,
            filter: {},
            loading: false,
        }
    },
    metaInfo() {
        return {
            title: this.$t("esl_instructor_sessions")
        }
    },
    methods: {
      async getData() {
            this.loading = true;
            const {id} =localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):null;
            try {
                const response =await EslInstructorService.getInstructorSession(id)
                this.sessions = response.data.data
                this.loading = false
            }catch (error) {
                this.showError(error);
            }
        },
        showDetail(sessionId) {
            this.process = 'course_detail'
            this.selectedData = this.sessions.find(session => session.id === sessionId)

            this.$refs.detailModal.$refs.commonModal.show()

        },
        formClear() {
            this.process = null;
            this.selectedData=null
            this.$refs.detailModal.$refs.commonModal.hide()
        },
        filterClear() {
            this.filter = {}
            this.getData()
        },
    },
    created() {
        this.getData()
    }
}
</script>
<style scoped>
.cursor {
    cursor: pointer;
}
</style>
